webpackJsonp([118030770820474],{

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(11);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles2 = __webpack_require__(243);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	
	  mainDiv: {
	    marginTop: '20px',
	    borderBottom: '1px solid rgba(0,0,0,.5)',
	    paddingLeft: '20px',
	    marginRight: '8em',
	    marginLeft: '8em'
	  },
	  policyClass: {
	    padding: '3rem'
	  }
	};
	
	var PolicyList = function PolicyList(_ref) {
	  var classes = _ref.classes,
	      title = _ref.title,
	      key = _ref.key,
	      summary = _ref.summary,
	      uid = _ref.uid;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: style.mainDiv, key: key },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, className: classes.policyContents },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, lg: 12, xl: 12, className: classes.centred },
	        _react2.default.createElement(
	          'div',
	          { className: classes.policyCentered },
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: classes.link, to: '/policies/' + uid },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'title', className: classes.h1text },
	              title
	            )
	          )
	        ),
	        _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: { __html: summary },
	          className: classes.allpoliciescontent
	        })
	      )
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(PolicyList);
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    text: _extends({}, (0, _mixins.RichText)(theme)),
	    policyContents: {
	      width: '100%',
	      height: '100%',
	      marginLeft: 'auto',
	      marginRight: 'auto'
	
	    },
	
	    policyCentered: {
	      width: '100%',
	      height: '100%',
	      display: 'flex',
	      padding: '3rem 3rem 0 3rem',
	      flexGrow: 1,
	      flexWrap: 'wrap',
	      alignItems: 'center',
	      justifyContent: 'center'
	    },
	    allpoliciescontent: _extends({}, (0, _mixins.RichText)(theme)),
	
	    h1text: {
	      fontSize: '2.1rem',
	      fontWeight: 600,
	      color: 'rgba(0,0,0,.7)',
	      fontFamily: theme.typography.body1.fontFamily,
	      marginTop: theme.spacing.unit * 5,
	      marginBottom: theme.spacing.unit * 5
	    },
	    link: {
	      textDecoration: 'none'
	
	    }
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _styles = __webpack_require__(11);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _policyList = __webpack_require__(593);
	
	var _policyList2 = _interopRequireDefault(_policyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PoliciesPage = function PoliciesPage(props) {
	
	  var policies = (0, _mapper.mapPolicies)(props.data.policies);
	  var policyPageData = (0, _mapper.mapPolicyPageData)(props.data.policiespagesdata);
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_banner2.default, {
	      uid: 'contact',
	      title: policyPageData.title,
	      subtitle: policyPageData.subtitle,
	      background: policyPageData.image
	
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '8em' } },
	      policies.map(function (policy) {
	        return _react2.default.createElement(_policyList2.default, { key: policy.id, title: policy.title.text, summary: policy.text[0].html, uid: policy.uid });
	      })
	    ),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policiesdata.edges })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_site2.default)(PoliciesPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-policies-js-dc7df7df9b4192c47611.js